// ======================================================
// PRODUCT DETAIL (BISON) - Thumbnails, variant options, quantity
// Variant switch updates: price, compare price, discount, SKU, stock, main image
// ======================================================



(function() {
  function getSectionId(sectionEl) {
    return sectionEl.dataset.sectionId || (sectionEl.id && sectionEl.id.replace('product-detail-', ''));
  }

  function syncMediaLayoutMode(sectionEl) {
    if (!sectionEl) return;
    var grid = sectionEl.querySelector('[data-product-media-grid]');
    var hasGridItems = !!(grid && grid.children && grid.children.length);
    sectionEl.classList.toggle('product-detail-bison--media-grid', hasGridItems);
  }

  function getVariantMediaSets(sectionEl, sectionId, variant) {
    var full = [];
    var thumb = [];
    if (variant && variant.image_urls && variant.image_urls.length) {
      full = variant.image_urls;
      thumb = (variant.image_thumb_urls && variant.image_thumb_urls.length) ? variant.image_thumb_urls : full;
    } else {
      var productMedia = window.productDetailBisonProductMedia && window.productDetailBisonProductMedia[sectionId];
      if (productMedia && productMedia.full && productMedia.full.length) {
        full = productMedia.full;
        thumb = (productMedia.thumb && productMedia.thumb.length) ? productMedia.thumb : full;
      } else if (variant && variant.image_url) {
        full = [variant.image_url];
        thumb = full;
      }
    }
    return { full: full, thumb: thumb };
  }

  function updateThumbnailArrowsVisibility(sectionEl) {
    var wrap = sectionEl.querySelector('[data-product-thumbnails-wrap]');
    var container = sectionEl.querySelector('[data-product-thumbnails]');
    if (!wrap || wrap.hidden || !container) return;
    var needsScroll = container.scrollWidth > container.clientWidth + 1;
    wrap.classList.toggle('thumbs-no-scroll', !needsScroll);
  }

  function setActiveThumbnail(sectionEl, fullSrc) {
    var container = sectionEl.querySelector('[data-product-thumbnails]');
    if (!container || !fullSrc) return;
    container.querySelectorAll('.thumbnail-item').forEach(function(thumb) {
      var match = thumb.dataset.thumbFull === fullSrc || thumb.src === fullSrc;
      thumb.classList.toggle('active', match);
    });
  }

  function renderVariantThumbnails(sectionEl, fullUrls, thumbUrls) {
    var wrap = sectionEl.querySelector('[data-product-thumbnails-wrap]');
    var container = sectionEl.querySelector('[data-product-thumbnails]');
    if (!wrap || !container) return;

    if (!fullUrls || fullUrls.length <= 1) {
      wrap.hidden = true;
      wrap.setAttribute('aria-hidden', 'true');
      container.innerHTML = '';
      return;
    }

    wrap.hidden = false;
    wrap.removeAttribute('aria-hidden');
    container.innerHTML = '';

    fullUrls.forEach(function(fullSrc, index) {
      var thumbSrc = (thumbUrls && thumbUrls[index]) ? thumbUrls[index] : fullSrc;
      var img = document.createElement('img');
      img.className = 'thumbnail-item product-detail-bison__zoomable' + (index === 0 ? ' active' : '');
      img.src = thumbSrc;
      img.alt = '';
      img.loading = 'lazy';
      img.setAttribute('width', '64');
      img.setAttribute('height', '64');
      img.dataset.thumbFull = fullSrc;
      container.appendChild(img);
    });

    updateThumbnailArrowsVisibility(sectionEl);
  }

  function formatMoney(cents, moneyFormat) {
    if (cents == null) return '';
    var amount = (cents / 100).toFixed(2);
    var fmt = moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{amount\}\}/g, amount).replace(/\{\{amount_no_decimals\}\}/g, Math.round(cents / 100));
  }

  function getSelectedVariant(sectionEl, sectionId) {
    var variants = window.productDetailBisonVariants && window.productDetailBisonVariants[sectionId];
    if (!variants || !variants.length) return null;
    var selected = {};
    sectionEl.querySelectorAll('[data-option-position][data-option-value].active').forEach(function(el) {
      if (el.classList.contains('is-unavailable') || el.closest('[data-product-sticky-atc]')) return;
      var pos = el.dataset.optionPosition;
      var val = el.dataset.optionValue;
      if (pos && val !== undefined) selected['option' + pos] = val;
    });
    return variants.find(function(v) {
      for (var i = 1; i <= 3; i++) {
        var key = 'option' + i;
        if (selected[key] !== undefined && v[key] !== selected[key]) return false;
      }
      return true;
    }) || null;
  }

  function getSelectedOptionsMap(sectionEl) {
    var selected = {};
    sectionEl.querySelectorAll('.color-item.active[data-option-position][data-option-value], .pack-btn.active[data-option-position][data-option-value]').forEach(function(el) {
      if (el.classList.contains('is-unavailable')) return;
      var pos = el.dataset.optionPosition;
      var val = el.dataset.optionValue;
      if (pos && val !== undefined) selected['option' + pos] = val;
    });
    return selected;
  }

  function isOptionValueAvailable(variants, optionPos, value, selected) {
    if (!variants || !variants.length || value == null) return false;
    var posKey = 'option' + optionPos;
    return variants.some(function(v) {
      if (String(v[posKey]) !== String(value)) return false;
      for (var i = 1; i <= 3; i++) {
        if (String(i) === String(optionPos)) continue;
        var key = 'option' + i;
        if (selected[key] == null || selected[key] === '') continue;
        if (v[key] == null || v[key] === '') continue;
        if (String(v[key]) !== String(selected[key])) return false;
      }
      return true;
    });
  }

  function updateOptionAvailability(sectionEl, sectionId) {
    var variants = window.productDetailBisonVariants && window.productDetailBisonVariants[sectionId];
    if (!variants || !variants.length) return;

    var positions = {};
    sectionEl.querySelectorAll('.color-item[data-option-position], .pack-btn[data-option-position]').forEach(function(el) {
      positions[el.dataset.optionPosition] = true;
    });

    var pass;
    for (pass = 0; pass < 3; pass++) {
      var selected = getSelectedOptionsMap(sectionEl);
      var selectionChanged = false;

      Object.keys(positions).forEach(function(pos) {
        var optionEls = sectionEl.querySelectorAll(
          '.color-item[data-option-position="' + pos + '"], .pack-btn[data-option-position="' + pos + '"]'
        );
        var firstAvailable = null;
        var activeEl = null;

        optionEls.forEach(function(el) {
          var value = el.dataset.optionValue;
          var available = isOptionValueAvailable(variants, pos, value, selected);
          el.classList.toggle('is-unavailable', !available);
          el.setAttribute('aria-hidden', available ? 'false' : 'true');
          if (el.tagName === 'BUTTON') el.disabled = !available;
          if (available && !firstAvailable) firstAvailable = el;
          if (el.classList.contains('active')) activeEl = el;
        });

        if (activeEl && activeEl.classList.contains('is-unavailable')) {
          activeEl.classList.remove('active');
          if (firstAvailable) {
            firstAvailable.classList.add('active');
            selectionChanged = true;
          }
        } else if (!activeEl && firstAvailable) {
          firstAvailable.classList.add('active');
          selectionChanged = true;
        }
      });

      selected = getSelectedOptionsMap(sectionEl);
      sectionEl.querySelectorAll('[data-sticky-dropdown]').forEach(function(dropdown) {
        var pos = dropdown.dataset.stickyOptionPosition;
        if (!pos) return;
        dropdown.querySelectorAll('.product-detail-sticky-atc__dropdown-option').forEach(function(opt) {
          var value = opt.dataset.stickyOptionValue;
          var available = isOptionValueAvailable(variants, pos, value, selected);
          opt.classList.toggle('is-unavailable', !available);
          opt.hidden = !available;
          var li = opt.closest('li');
          if (li) li.hidden = !available;
        });
      });

      if (!selectionChanged) break;
    }

    syncStickySelectsFromMain(sectionEl);
  }

  function updateAddButtonState(sectionEl, variant) {
    var addText = (typeof window !== 'undefined' && window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    var soldOutText = (typeof window !== 'undefined' && window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    var mainBtn = sectionEl.querySelector('.product-detail-add-btn');
    var mainTextEl = sectionEl.querySelector('.product-detail-add-btn__text');
    if (mainBtn && mainTextEl) {
      if (variant && !variant.available) {
        mainBtn.disabled = true;
        mainTextEl.textContent = soldOutText;
      } else {
        mainBtn.disabled = false;
        mainTextEl.textContent = addText;
      }
    }
    var buyNowBtn = sectionEl.querySelector('.buy-now-btn');
    if (buyNowBtn) {
      buyNowBtn.disabled = !!(variant && !variant.available);
    }
    var stickyBtn = sectionEl.querySelector('[data-sticky-add]');
    var stickyTextEl = sectionEl.querySelector('[data-sticky-add-text]');
    if (stickyBtn && stickyTextEl) {
      if (variant && !variant.available) {
        stickyBtn.disabled = true;
        stickyTextEl.textContent = soldOutText;
      } else {
        stickyBtn.disabled = false;
        stickyTextEl.textContent = addText;
      }
    }
  }

  function syncStickySelectsFromMain(sectionEl) {
    sectionEl.querySelectorAll('[data-sticky-dropdown]').forEach(function(dropdown) {
      var pos = dropdown.dataset.stickyOptionPosition;
      if (!pos) return;
      var activeEl = sectionEl.querySelector('.color-item.active[data-option-position="' + pos + '"]') ||
        sectionEl.querySelector('.pack-btn.active[data-option-position="' + pos + '"]');
      if (activeEl && activeEl.dataset.optionValue != null) {
        setStickyDropdownValue(dropdown, activeEl.dataset.optionValue);
      }
    });
  }

  function syncMainOptionsFromSticky(sectionEl) {
    sectionEl.querySelectorAll('[data-sticky-dropdown]').forEach(function(dropdown) {
      var pos = dropdown.dataset.stickyOptionPosition;
      var val = getStickyDropdownValue(dropdown);
      if (!pos || val == null) return;
      sectionEl.querySelectorAll('[data-option-position="' + pos + '"][data-option-value]').forEach(function(el) {
        el.classList.toggle('active', el.dataset.optionValue === val);
      });
    });
  }

  function getStickyDropdownValue(dropdown) {
    var selected = dropdown.querySelector('.product-detail-sticky-atc__dropdown-option.is-selected');
    return selected ? selected.dataset.stickyOptionValue : null;
  }

  function setStickyDropdownValue(dropdown, value) {
    if (!dropdown || value == null) return;
    var textEl = dropdown.querySelector('[data-sticky-dropdown-text]');
    dropdown.querySelectorAll('.product-detail-sticky-atc__dropdown-option').forEach(function(opt) {
      var isSelected = opt.dataset.stickyOptionValue === value;
      opt.classList.toggle('is-selected', isSelected);
      opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
    if (textEl) textEl.textContent = value;
  }

  function closeStickyDropdown(dropdown) {
    if (!dropdown) return;
    var trigger = dropdown.querySelector('.product-detail-sticky-atc__dropdown-trigger');
    var panel = dropdown.querySelector('.product-detail-sticky-atc__dropdown-panel');
    dropdown.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  }

  function closeAllStickyDropdowns(sectionEl, exceptDropdown) {
    sectionEl.querySelectorAll('[data-sticky-dropdown]').forEach(function(dropdown) {
      if (exceptDropdown && dropdown === exceptDropdown) return;
      closeStickyDropdown(dropdown);
    });
  }

  function openStickyDropdown(dropdown) {
    if (!dropdown) return;
    var trigger = dropdown.querySelector('.product-detail-sticky-atc__dropdown-trigger');
    var panel = dropdown.querySelector('.product-detail-sticky-atc__dropdown-panel');
    dropdown.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.hidden = false;
  }

  function initStickyDropdowns(sectionEl, sectionId) {
    sectionEl.querySelectorAll('[data-sticky-dropdown]').forEach(function(dropdown) {
      if (dropdown.dataset.dropdownBound === '1') return;
      dropdown.dataset.dropdownBound = '1';

      var trigger = dropdown.querySelector('.product-detail-sticky-atc__dropdown-trigger');
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          var isOpen = dropdown.classList.contains('is-open');
          closeAllStickyDropdowns(sectionEl);
          if (!isOpen) openStickyDropdown(dropdown);
        });
      }

      dropdown.querySelectorAll('.product-detail-sticky-atc__dropdown-option').forEach(function(optionBtn) {
        optionBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var value = optionBtn.dataset.stickyOptionValue;
          if (value == null) return;
          setStickyDropdownValue(dropdown, value);
          closeStickyDropdown(dropdown);
          syncMainOptionsFromSticky(sectionEl);
          updateOptionAvailability(sectionEl, sectionId);
          updateVariantFromOptions(sectionEl, sectionId);
        });
      });
    });

    if (!sectionEl.__stickyDropdownDocBound) {
      sectionEl.__stickyDropdownDocBound = true;
      document.addEventListener('click', function(e) {
        if (!e.target.closest('[data-sticky-dropdown]')) {
          closeAllStickyDropdowns(sectionEl);
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeAllStickyDropdowns(sectionEl);
      });
    }
  }

  function updateColorOptionLabel(sectionEl, variant) {
    var labelEl = sectionEl.querySelector('[data-color-option-label]');
    if (!labelEl) return;
    var textEl = labelEl.querySelector('[data-color-option-label-text]') || labelEl;
    var optionName = labelEl.dataset.colorOptionName || 'COLOR';
    var infoCol = sectionEl.querySelector('.product-detail-bison__col-info');
    var colorPos = infoCol && infoCol.dataset.colorOptionPosition;
    var selectedColor = '';
    if (colorPos && variant) {
      selectedColor = variant['option' + colorPos] || '';
    }
    if (!selectedColor) {
      var activeColor = sectionEl.querySelector('.color-item.active[data-option-value]');
      if (activeColor) selectedColor = activeColor.dataset.optionValue || '';
    }
    textEl.textContent = selectedColor ? optionName + ': ' + selectedColor : optionName;
  }

  function updateVariantFromOptions(sectionEl, sectionId) {
    var variant = getSelectedVariant(sectionEl, sectionId);
    if (!variant) return;

    var moneyFormat = sectionEl.querySelector('[data-money-format]') && sectionEl.querySelector('[data-money-format]').dataset.moneyFormat;

    var priceEl = sectionEl.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);

    var compareEl = sectionEl.querySelector('[data-compare-price]');
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    var discountEl = sectionEl.querySelector('[data-discount-badge]');
    if (discountEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        discountEl.textContent = '-' + pct + '%';
        discountEl.style.display = '';
      } else {
        discountEl.textContent = '';
        discountEl.style.display = 'none';
      }
    }

    var skuEl = sectionEl.querySelector('.product-detail-sku');
    if (skuEl) skuEl.textContent = 'SKU: ' + (variant.sku || variant.id);

    var descEl = sectionEl.querySelector('[data-product-desc]');
    if (descEl && variant.description != null) descEl.textContent = variant.description;

    var stockEl = sectionEl.querySelector('[data-stock]');
    if (stockEl) {
      if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
        stockEl.textContent = variant.inventory_quantity + ' ' + (stockEl.dataset.stockLabel || 'stocks remaining');
        stockEl.style.display = '';
      } else {
        stockEl.style.display = 'none';
      }
    }

    var mainImg = sectionEl.querySelector('.main-product-image');
    if (mainImg) {
      var mediaSets = getVariantMediaSets(sectionEl, sectionId, variant);
      var mediaUrls = mediaSets.full;
      var mainSrc = mediaUrls[0] || null;
      renderVariantMediaGrid(sectionEl, mediaUrls);
      renderVariantThumbnails(sectionEl, mediaUrls, mediaSets.thumb);
      if (mainSrc) {
        setMainImageWithLoader(sectionEl, mainImg, mainSrc);
        setActiveThumbnail(sectionEl, mainSrc);
      }
    }

    // Update product title: base from variant metafield (custom.variant_title) or product title, suffix from options
    var titleBaseEl = sectionEl.querySelector('[data-title-base]');
    var h1El = sectionEl.querySelector('.product-detail-bison__title');
    var productTitleFallback = (h1El && h1El.dataset && h1El.dataset.productTitle) || '';
    if (titleBaseEl) {
      titleBaseEl.textContent = (variant.title != null && variant.title !== '') ? variant.title : productTitleFallback;
    }
    var titleVariantsEl = sectionEl.querySelector('[data-title-variants]');
    var showTitleSuffix = sectionEl.dataset.showTitleSuffix !== 'false';
    if (titleVariantsEl) {
      if (!showTitleSuffix) {
        titleVariantsEl.textContent = '';
        titleVariantsEl.hidden = true;
      } else {
        titleVariantsEl.hidden = false;
        var parts = [];
        for (var o = 1; o <= 3; o++) {
          var val = variant['option' + o];
          if (val) parts.push(val);
        }
        titleVariantsEl.textContent = parts.length ? ' - ' + parts.join(' - ') : '';
      }
    }

    updateColorOptionLabel(sectionEl, variant);

    var stickyPriceEl = sectionEl.querySelector('[data-sticky-price]');
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price, moneyFormat);

    updateAddButtonState(sectionEl, variant);
    syncStickySelectsFromMain(sectionEl);

    document.dispatchEvent(
      new CustomEvent('bison:variant-change', {
        detail: { variantId: variant.id, sectionId: sectionId },
      })
    );
  }

  function setMainImageWithLoader(sectionEl, mainImg, newSrc, callback) {
    var wrapper = mainImg && mainImg.closest('.product-hero-image-wrapper');
    if (!mainImg || !newSrc) {
      if (callback) callback();
      return;
    }
    if (wrapper) wrapper.classList.add('is-loading');
    var done = function() {
      if (wrapper) wrapper.classList.remove('is-loading');
      if (callback) callback();
    };
    mainImg.onload = function() { mainImg.onload = mainImg.onerror = null; done(); };
    mainImg.onerror = function() { mainImg.onload = mainImg.onerror = null; done(); };
    mainImg.src = newSrc;
    if (mainImg.complete && mainImg.naturalWidth) {
      mainImg.onload = mainImg.onerror = null;
      done();
    }
  }

  function renderVariantMediaGrid(sectionEl, fullUrls) {
    var grid = sectionEl.querySelector('[data-product-media-grid]');
    if (!grid) return;
    grid.innerHTML = '';
    if (!fullUrls || fullUrls.length <= 1) {
      syncMediaLayoutMode(sectionEl);
      return;
    }
    for (var i = 1; i < fullUrls.length; i++) {
      var cell = document.createElement('div');
      cell.className = 'product-media-grid__item';
      var img = document.createElement('img');
      img.className = 'product-media-grid__item-image product-detail-bison__zoomable';
      img.src = fullUrls[i];
      img.alt = '';
      img.loading = 'lazy';
      img.setAttribute('width', 800);
      img.setAttribute('height', 800);
      cell.appendChild(img);
      grid.appendChild(cell);
    }
    syncMediaLayoutMode(sectionEl);
  }

  function initSplitScroll(sectionEl) {
    if (!sectionEl) return;
    if (typeof sectionEl.__pdbSplitScrollCleanup === 'function') {
      sectionEl.__pdbSplitScrollCleanup();
      sectionEl.__pdbSplitScrollCleanup = null;
    }

    var enabled = sectionEl.dataset.splitScrollEnabled === 'true';
    var detailsCol = sectionEl.querySelector('.product-detail-bison__col-info');
    var hasMediaGrid = sectionEl.classList.contains('product-detail-bison--media-grid');
    if (!enabled || !detailsCol || hasMediaGrid) {
      return;
    }

    var desktopQuery = window.matchMedia('(min-width: 992px)');
    function inSplitRange() {
      if (!desktopQuery.matches) return false;
      var rect = sectionEl.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
      return rect.top <= 0 && rect.bottom > viewportH;
    }

    function canScrollDetailsDown() {
      return detailsCol.scrollTop + detailsCol.clientHeight < detailsCol.scrollHeight - 1;
    }

    function canScrollDetailsUp() {
      return detailsCol.scrollTop > 0;
    }

    function onWheel(e) {
      if (!desktopQuery.matches) return;
      if (!inSplitRange()) return;
      if (!e || typeof e.deltaY !== 'number' || e.deltaY === 0) return;
      if (!detailsCol.contains(e.target)) return;

      if (e.deltaY > 0 && canScrollDetailsDown()) {
        e.preventDefault();
        detailsCol.scrollTop += e.deltaY;
        return;
      }

      if (e.deltaY < 0 && canScrollDetailsUp()) {
        e.preventDefault();
        detailsCol.scrollTop += e.deltaY;
      }
    }

    function onMediaChange() {
      if (!desktopQuery.matches) detailsCol.scrollTop = 0;
    }

    window.addEventListener('wheel', onWheel, { passive: false });
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onMediaChange);
    else if (desktopQuery.addListener) desktopQuery.addListener(onMediaChange);

    sectionEl.__pdbSplitScrollCleanup = function() {
      window.removeEventListener('wheel', onWheel);
      if (desktopQuery.removeEventListener) desktopQuery.removeEventListener('change', onMediaChange);
      else if (desktopQuery.removeListener) desktopQuery.removeListener(onMediaChange);
    };
  }

  function initMediaParallax(sectionEl) {
    if (!sectionEl) return;
    if (typeof sectionEl.__pdbParallaxCleanup === 'function') {
      sectionEl.__pdbParallaxCleanup();
      sectionEl.__pdbParallaxCleanup = null;
    }

    var mediaCol = sectionEl.querySelector('.product-detail-bison__col-media');
    if (!mediaCol) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var desktopQuery = window.matchMedia('(min-width: 992px)');
    var ticking = false;
    var maxShift = 110;

    function shouldRun() {
      return desktopQuery.matches && sectionEl.classList.contains('product-detail-bison--media-grid');
    }

    function applyParallax() {
      ticking = false;
      if (!shouldRun()) {
        sectionEl.style.setProperty('--pdb-media-parallax-y', '0px');
        return;
      }
      var rect = sectionEl.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
      if (viewportH <= 0) return;
      var progress = (viewportH - rect.top) / (viewportH + rect.height);
      if (!Number.isFinite(progress)) progress = 0;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      var offset = (progress - 0.5) * (maxShift * 2);
      if (offset < -maxShift) offset = -maxShift;
      if (offset > maxShift) offset = maxShift;
      sectionEl.style.setProperty('--pdb-media-parallax-y', offset.toFixed(2) + 'px');
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(applyParallax);
    }

    function onMediaChange() {
      if (!shouldRun()) {
        sectionEl.style.setProperty('--pdb-media-parallax-y', '0px');
      } else {
        onScrollOrResize();
      }
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onMediaChange);
    else if (desktopQuery.addListener) desktopQuery.addListener(onMediaChange);
    onScrollOrResize();

    sectionEl.__pdbParallaxCleanup = function() {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      if (desktopQuery.removeEventListener) desktopQuery.removeEventListener('change', onMediaChange);
      else if (desktopQuery.removeListener) desktopQuery.removeListener(onMediaChange);
      sectionEl.style.setProperty('--pdb-media-parallax-y', '0px');
    };
  }

  function initDetailRecommendations(sectionEl) {
    if (!sectionEl) return;
    var track = sectionEl.querySelector('[data-detail-rec-track]');
    if (!track) return;
    var items = track.querySelectorAll('[data-detail-rec-item]');
    var prev = sectionEl.querySelector('[data-detail-rec-arrow="prev"]');
    var next = sectionEl.querySelector('[data-detail-rec-arrow="next"]');
    var index = 0;

    function addToCart(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Math.max(1, Number(quantity) || 1),
        }),
      }).then(function(res) {
        if (!res.ok) throw new Error('Failed to add recommended product');
        return res.json();
      });
    }

    function updateTrack() {
      if (!items.length) return;
      var maxIndex = Math.max(items.length - 1, 0);
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;
      var itemWidth = items[0].getBoundingClientRect().width;
      var gap = 12;
      var offset = index * (itemWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex;
    }

    if (items.length > 1) {
      if (prev) {
        prev.addEventListener('click', function() {
          index -= 1;
          updateTrack();
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          index += 1;
          updateTrack();
        });
      }
      window.addEventListener('resize', updateTrack);
      updateTrack();
    } else if (prev && next) {
      prev.disabled = true;
      next.disabled = true;
    }

    if (!sectionEl.dataset.detailRecAddBound) {
      sectionEl.dataset.detailRecAddBound = '1';
      sectionEl.addEventListener('click', function(event) {
        var addBtn = event.target.closest('[data-detail-rec-add]');
        if (!addBtn) return;
        event.preventDefault();

        var variantId = addBtn.getAttribute('data-detail-rec-variant-id');
        var quantity = addBtn.getAttribute('data-detail-rec-quantity') || '1';
        if (!variantId) return;

        var originalLabel = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Adding...';
        addToCart(variantId, quantity)
          .then(function() {
            if (window.BisonStaticCartDrawer && typeof window.BisonStaticCartDrawer.open === 'function') {
              window.BisonStaticCartDrawer.open();
              return;
            }
            if (window.location && window.location.pathname !== '/cart') {
              window.location.href = '/cart';
            }
          })
          .catch(function(error) {
            console.error(error);
          })
          .finally(function() {
            addBtn.textContent = originalLabel;
            addBtn.classList.remove('is-loading');
            addBtn.disabled = false;
          });
      });
    }
  }

  function initProductLightbox(sectionEl, sectionId) {
    var lightbox = sectionEl.querySelector('[data-product-detail-lightbox]');
    if (!lightbox || lightbox.dataset.lightboxBound === '1') return;
    lightbox.dataset.lightboxBound = '1';

    var stageEl = lightbox.querySelector('[data-lightbox-stage]');
    var viewportEl = lightbox.querySelector('[data-lightbox-viewport]');
    var canvasEl = lightbox.querySelector('[data-lightbox-canvas]');
    var imageEl = lightbox.querySelector('[data-lightbox-image]');
    var counterEl = lightbox.querySelector('[data-lightbox-counter]');
    var thumbsEl = lightbox.querySelector('[data-lightbox-thumbs]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var state = {
      urls: [],
      thumbUrls: [],
      index: 0,
      scale: 1,
      panX: 0,
      panY: 0,
      baseWidth: 0,
      baseHeight: 0
    };
    var dragState = { active: false, moved: false, startX: 0, startY: 0, panX: 0, panY: 0 };
    var touchPanState = { active: false, startX: 0, startY: 0, panX: 0, panY: 0 };
    var touchSwipeStartX = 0;
    var MIN_SCALE = 1;
    var MAX_SCALE = 2.5;
    var ZOOM_STEP = 0.2;

    function isZoomed() {
      return state.scale > 1.02;
    }

    function updateBaseSize() {
      if (!imageEl) return;
      state.baseWidth = imageEl.offsetWidth;
      state.baseHeight = imageEl.offsetHeight;
    }

    function applyTransform(animate) {
      if (!canvasEl || !viewportEl || !imageEl) return;
      canvasEl.style.transition = animate ? 'transform 0.18s ease-out' : 'none';
      canvasEl.style.transform =
        'translate(-50%, -50%) translate(' + state.panX + 'px, ' + state.panY + 'px) scale(' + state.scale + ')';
      viewportEl.classList.toggle('is-zoomed', isZoomed());
      viewportEl.classList.toggle('is-dragging', dragState.active);
      imageEl.classList.toggle('is-zoomed', isZoomed());
    }

    function resetZoom() {
      state.scale = 1;
      state.panX = 0;
      state.panY = 0;
      dragState.active = false;
      dragState.moved = false;
      touchPanState.active = false;
      applyTransform(false);
      window.requestAnimationFrame(updateBaseSize);
    }

    function zoomAtPoint(clientX, clientY, nextScale, animate) {
      if (!viewportEl) return;
      nextScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, nextScale));

      if (nextScale <= MIN_SCALE) {
        resetZoom();
        return;
      }

      var rect = viewportEl.getBoundingClientRect();
      var focalX = clientX - rect.left - rect.width / 2;
      var focalY = clientY - rect.top - rect.height / 2;
      var ratio = nextScale / state.scale;

      state.panX = focalX - (focalX - state.panX) * ratio;
      state.panY = focalY - (focalY - state.panY) * ratio;
      state.scale = nextScale;
      applyTransform(animate !== false);
    }

    function endDrag() {
      dragState.active = false;
      if (viewportEl) viewportEl.classList.remove('is-dragging');
    }

    function toggleZoomAtPoint(clientX, clientY) {
      if (isZoomed()) {
        resetZoom();
      } else {
        zoomAtPoint(clientX, clientY, 2, true);
      }
    }

    function normalizeSrc(src) {
      return String(src || '').split('?')[0];
    }

    function fileKey(src) {
      var file = normalizeSrc(src).split('/').pop() || '';
      return file.replace(/_(\d+x\d+|\d+x)(?=\.[a-z]+$)/i, '');
    }

    function getGallerySets() {
      var variant = getSelectedVariant(sectionEl, sectionId);
      return getVariantMediaSets(sectionEl, sectionId, variant);
    }

    function getIndexFromSrc(urls, src) {
      if (!src || !urls.length) return 0;
      var target = normalizeSrc(src);
      var targetKey = fileKey(src);
      for (var i = 0; i < urls.length; i++) {
        if (normalizeSrc(urls[i]) === target) return i;
      }
      for (var j = 0; j < urls.length; j++) {
        if (fileKey(urls[j]) === targetKey) return j;
      }
      return 0;
    }

    function getPreferredSrcFromTarget(target) {
      if (!target) return '';
      if (target.classList.contains('thumbnail-item')) {
        return target.dataset.thumbFull || target.currentSrc || target.src || '';
      }
      return target.currentSrc || target.src || '';
    }

    function renderThumbs() {
      if (!thumbsEl) return;
      thumbsEl.innerHTML = '';
      if (!state.urls.length || state.urls.length <= 1) {
        thumbsEl.hidden = true;
        return;
      }
      thumbsEl.hidden = false;
      state.urls.forEach(function (fullSrc, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-detail-lightbox__thumb' + (i === state.index ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === state.index ? 'true' : 'false');
        btn.dataset.lightboxThumbIndex = String(i);
        var img = document.createElement('img');
        img.src = state.thumbUrls[i] || fullSrc;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 64;
        img.height = 64;
        btn.appendChild(img);
        thumbsEl.appendChild(btn);
      });
    }

    function updateNavState() {
      var total = state.urls.length;
      if (counterEl) {
        counterEl.textContent = total > 1 ? (state.index + 1) + ' / ' + total : '';
        counterEl.hidden = total <= 1;
      }
      if (prevBtn) prevBtn.disabled = total <= 1;
      if (nextBtn) nextBtn.disabled = total <= 1;
      if (thumbsEl) {
        thumbsEl.querySelectorAll('[data-lightbox-thumb-index]').forEach(function (btn) {
          var idx = parseInt(btn.dataset.lightboxThumbIndex, 10);
          var active = idx === state.index;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }

    function setLightboxImage(src, animate) {
      if (!imageEl || !src) return;
      if (animate) imageEl.classList.add('is-changing');
      imageEl.src = src;
      imageEl.alt = (sectionEl.querySelector('[data-product-title]') || {}).textContent || 'Product image';
    }

    function updateSlide(animate) {
      if (!state.urls.length || !imageEl) return;
      var total = state.urls.length;
      state.index = ((state.index % total) + total) % total;
      resetZoom();
      setLightboxImage(state.urls[state.index], animate);
      updateNavState();
    }

    function openLightboxWithUrls(urls, thumbUrls, preferredSrc, altText) {
      state.urls = (urls && urls.length) ? urls.slice() : [];
      state.thumbUrls = (thumbUrls && thumbUrls.length) ? thumbUrls.slice() : state.urls.slice();
      if (!state.urls.length) return;

      state.index = preferredSrc ? getIndexFromSrc(state.urls, preferredSrc) : 0;
      resetZoom();

      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      setLightboxImage(state.urls[state.index], false);
      if (imageEl && altText) imageEl.alt = altText;
      renderThumbs();
      updateNavState();
    }

    function openLightbox(clickedTarget) {
      var sets = getGallerySets();
      var urls = (sets && sets.full && sets.full.length) ? sets.full : [];
      if (!urls.length) return;
      var altText = (sectionEl.querySelector('[data-product-title]') || {}).textContent || 'Product image';
      openLightboxWithUrls(urls, sets.thumb, getPreferredSrcFromTarget(clickedTarget), altText);
    }

    function bindSizeGuideLightbox() {
      if (window.__pdbSizeGuideLightboxBound) return;
      window.__pdbSizeGuideLightboxBound = true;

      document.addEventListener('click', function (e) {
        var img = e.target.closest('.tabs-bison-size-guide-grid__img.product-detail-bison__zoomable');
        if (!img) return;
        if (!lightbox || typeof openLightboxWithUrls !== 'function') return;

        var grid = img.closest('.tabs-bison-size-guide-grid');
        if (!grid) return;

        var imgs = grid.querySelectorAll('.tabs-bison-size-guide-grid__img');
        var urls = [];
        var thumbs = [];
        imgs.forEach(function (el) {
          urls.push(el.getAttribute('data-lightbox-full') || el.currentSrc || el.src || '');
          thumbs.push(el.currentSrc || el.src || '');
        });

        e.preventDefault();
        openLightboxWithUrls(
          urls,
          thumbs,
          img.getAttribute('data-lightbox-full') || img.currentSrc || img.src || '',
          img.alt || 'Size guide'
        );
      });
    }

    window.BisonProductDetailLightbox = window.BisonProductDetailLightbox || {};
    window.BisonProductDetailLightbox.openWithUrls = openLightboxWithUrls;
    bindSizeGuideLightbox();

    function closeLightbox() {
      resetZoom();
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (!lightbox.classList.contains('is-open')) {
          lightbox.hidden = true;
          document.body.style.overflow = '';
        }
      }, 260);
    }

    function stepLightbox(delta) {
      if (!state.urls.length) return;
      state.index += delta;
      updateSlide(true);
    }

    if (imageEl) {
      imageEl.addEventListener('load', function () {
        imageEl.classList.remove('is-changing');
        if (!isZoomed()) {
          resetZoom();
          updateBaseSize();
        }
      });
    }

    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeLightbox();
      });
    });

    if (stageEl) {
      stageEl.addEventListener('click', function (e) {
        if (dragState.moved) return;
        if (imageEl && (e.target === imageEl || imageEl.contains(e.target))) return;
        if (e.target.closest('[data-lightbox-prev], [data-lightbox-next]')) return;
        closeLightbox();
      });
    }

    if (viewportEl) {
      viewportEl.addEventListener('click', function (e) {
        if (dragState.moved) return;
        if (imageEl && (e.target === imageEl || imageEl.contains(e.target))) return;
        closeLightbox();
      });
    }

    if (imageEl) {
      var clickZoomTimer = null;

      imageEl.addEventListener('dblclick', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (clickZoomTimer) {
          window.clearTimeout(clickZoomTimer);
          clickZoomTimer = null;
        }
        if (dragState.moved) return;
        toggleZoomAtPoint(e.clientX, e.clientY);
      });

      imageEl.addEventListener('click', function (e) {
        e.stopPropagation();
        if (dragState.moved) return;

        var clickX = e.clientX;
        var clickY = e.clientY;

        if (clickZoomTimer) window.clearTimeout(clickZoomTimer);
        clickZoomTimer = window.setTimeout(function () {
          clickZoomTimer = null;
          toggleZoomAtPoint(clickX, clickY);
        }, 220);
      });
    }

    if (!window.__pdbLightboxDragBound) {
      window.__pdbLightboxDragBound = true;

      document.addEventListener('mousemove', function (e) {
        var ctx = window.__pdbLightboxDragCtx;
        if (!ctx || !ctx.dragState.active) return;
        var dx = e.clientX - ctx.dragState.startX;
        var dy = e.clientY - ctx.dragState.startY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) ctx.dragState.moved = true;
        ctx.state.panX = ctx.dragState.panX + dx;
        ctx.state.panY = ctx.dragState.panY + dy;
        ctx.applyTransform(false);
      });

      document.addEventListener('mouseup', function () {
        var ctx = window.__pdbLightboxDragCtx;
        if (!ctx || !ctx.dragState.active) return;
        window.setTimeout(function () {
          ctx.dragState.moved = false;
        }, 0);
        ctx.endDrag();
        window.__pdbLightboxDragCtx = null;
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stepLightbox(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stepLightbox(1);
      });
    }

    if (thumbsEl) {
      thumbsEl.addEventListener('click', function (e) {
        var thumbBtn = e.target.closest('[data-lightbox-thumb-index]');
        if (!thumbBtn) return;
        e.stopPropagation();
        var idx = parseInt(thumbBtn.dataset.lightboxThumbIndex, 10);
        if (isNaN(idx) || idx === state.index) return;
        state.index = idx;
        updateSlide(true);
      });
    }

    if (viewportEl) {
      viewportEl.addEventListener('mousedown', function (e) {
        if (!isZoomed() || e.button !== 0) return;
        if (imageEl && !imageEl.contains(e.target) && e.target !== imageEl) return;
        dragState.active = true;
        dragState.moved = false;
        dragState.startX = e.clientX;
        dragState.startY = e.clientY;
        dragState.panX = state.panX;
        dragState.panY = state.panY;
        viewportEl.classList.add('is-dragging');
        window.__pdbLightboxDragCtx = {
          state: state,
          dragState: dragState,
          viewportEl: viewportEl,
          applyTransform: applyTransform,
          endDrag: endDrag
        };
        e.preventDefault();
      });

      viewportEl.addEventListener('wheel', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        e.preventDefault();
        var delta = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
        zoomAtPoint(e.clientX, e.clientY, state.scale + delta, false);
      }, { passive: false });

      viewportEl.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        if (isZoomed()) {
          touchPanState.active = true;
          touchPanState.startX = e.touches[0].clientX;
          touchPanState.startY = e.touches[0].clientY;
          touchPanState.panX = state.panX;
          touchPanState.panY = state.panY;
          return;
        }
        touchSwipeStartX = e.touches[0].clientX;
      }, { passive: true });

      viewportEl.addEventListener('touchmove', function (e) {
        if (!touchPanState.active || !e.touches || !e.touches[0]) return;
        e.preventDefault();
        state.panX = touchPanState.panX + (e.touches[0].clientX - touchPanState.startX);
        state.panY = touchPanState.panY + (e.touches[0].clientY - touchPanState.startY);
        applyTransform(false);
      }, { passive: false });

      viewportEl.addEventListener('touchend', function (e) {
        if (touchPanState.active) {
          touchPanState.active = false;
          return;
        }
        if (isZoomed()) return;
        var touchEndX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : 0;
        var delta = touchEndX - touchSwipeStartX;
        if (Math.abs(delta) < 40) return;
        stepLightbox(delta < 0 ? 1 : -1);
      }, { passive: true });
    }

    if (!sectionEl.dataset.lightboxMediaBound) {
      sectionEl.dataset.lightboxMediaBound = '1';
      sectionEl.addEventListener('click', function (e) {
        var zoomable = e.target.closest('.product-detail-bison__zoomable');
        if (!zoomable || !sectionEl.contains(zoomable)) return;
        var sets = getGallerySets();
        if (!sets.full || !sets.full.length) return;
        e.preventDefault();
        openLightbox(zoomable);
      });
    }

    if (!window.__pdbLightboxKeyBound) {
      window.__pdbLightboxKeyBound = true;
      document.addEventListener('keydown', function (e) {
        var openBox = document.querySelector('.product-detail-lightbox.is-open');
        if (!openBox) return;
        if (e.key === 'Escape') {
          var closeBtn = openBox.querySelector('.product-detail-lightbox__close');
          if (closeBtn) closeBtn.click();
        } else if (e.key === 'ArrowLeft') {
          var prev = openBox.querySelector('[data-lightbox-prev]');
          if (prev) prev.click();
        } else if (e.key === 'ArrowRight') {
          var next = openBox.querySelector('[data-lightbox-next]');
          if (next) next.click();
        }
      });
    }

    applyTransform(false);
  }

  function performAddToCart(sectionEl, sectionId, triggerBtn) {
    var addError = sectionEl.querySelector('[data-add-error]');
    var variant = getSelectedVariant(sectionEl, sectionId);
    var qtyEl = sectionEl.querySelector('.qty-val');
    var qty = (qtyEl && (parseInt(qtyEl.value || qtyEl.textContent, 10) || 1)) || 1;
    qty = Math.min(99, Math.max(1, isNaN(qty) ? 1 : qty));
    if (addError) { addError.style.display = 'none'; addError.textContent = ''; }
    if (!variant) {
      if (addError) {
        addError.textContent = (typeof window !== 'undefined' && window.variantStrings && window.variantStrings.unavailable) || 'Variant unavailable';
        addError.style.display = 'block';
      }
      return Promise.resolve(false);
    }
    if (!variant.available) return Promise.resolve(false);

    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', qty);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function(s) { return s.id; });
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', typeof window !== 'undefined' && window.location ? window.location.pathname : '');
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    var buttons = [];
    if (triggerBtn) buttons.push(triggerBtn);
    var mainBtn = sectionEl.querySelector('.product-detail-add-btn');
    var stickyBtn = sectionEl.querySelector('[data-sticky-add]');
    if (mainBtn && buttons.indexOf(mainBtn) === -1) buttons.push(mainBtn);
    if (stickyBtn && buttons.indexOf(stickyBtn) === -1) buttons.push(stickyBtn);
    buttons.forEach(function(btn) {
      btn.disabled = true;
      btn.classList.add('loading');
    });

    var routes = typeof window !== 'undefined' && window.routes;
    var cartAddUrl = (routes && routes.cart_add_url) || '/cart/add.js';
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    }).then(function(res) { return res.json(); }).then(function(data) {
      if (data.status) {
        if (addError) {
          addError.textContent = data.description || data.message || 'Unable to add to cart';
          addError.style.display = 'block';
        }
        return false;
      }
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-detail-bison', productVariantId: variant.id, cartData: data }); } catch (e) {}
      }
      if (cart && typeof cart.renderContents === 'function') cart.renderContents(data);
      if (window.BisonStaticCartDrawer && typeof window.BisonStaticCartDrawer.open === 'function') {
        window.BisonStaticCartDrawer.open();
      }
      return true;
    }).catch(function() {
      if (addError) {
        addError.textContent = (typeof window !== 'undefined' && window.cartStrings && window.cartStrings.error) || 'Unable to add to cart';
        addError.style.display = 'block';
      }
      return false;
    }).finally(function() {
      buttons.forEach(function(btn) {
        btn.classList.remove('loading');
      });
      updateAddButtonState(sectionEl, getSelectedVariant(sectionEl, sectionId));
    });
  }

  function initJudgemeReviewsLink(sectionEl) {
    var ratingEl = sectionEl.querySelector('.product-star-rating');
    if (!ratingEl) return;

    ratingEl.classList.add('product-star-rating--reviews-link');
    ratingEl.setAttribute('role', 'link');
    ratingEl.setAttribute('tabindex', '0');
    ratingEl.setAttribute('aria-label', 'Read product reviews');

    function openReviews(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (window.BisonTabsBison && typeof window.BisonTabsBison.openReviewsTab === 'function') {
        window.BisonTabsBison.openReviewsTab();
        return;
      }

      var reviewsRoot = document.querySelector('.tabs-bison [data-tabs-bison-reviews-app]');
      var tabsSection = reviewsRoot && reviewsRoot.closest('.tabs-bison');
      if (!tabsSection) return;

      var reviewBtn = tabsSection.querySelector('.feature-tabs .nav-link[data-tab$="-reviews"]');
      if (reviewBtn) reviewBtn.click();
    }

    ratingEl.addEventListener('click', openReviews, true);
    ratingEl.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        openReviews(event);
      }
    });
  }

  function initStickyMobileAtc(sectionEl, sectionId) {
    var addBlock = sectionEl.querySelector('.product-detail-add-block');
    var stickyBar = sectionEl.querySelector('[data-product-sticky-atc]');
    if (!addBlock || !stickyBar || stickyBar.dataset.stickyBound === '1') return;
    stickyBar.dataset.stickyBound = '1';

    var mobileMq = window.matchMedia('(max-width: 991px)');

    function setStickyVisible(visible) {
      var shouldShow = !!(visible && mobileMq.matches);
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.documentElement.classList.toggle('product-detail-sticky-atc-active', shouldShow);
      if (!shouldShow) closeAllStickyDropdowns(sectionEl);
    }

    function updateStickyVisibility() {
      if (!mobileMq.matches) {
        setStickyVisible(false);
        return;
      }
      var rect = addBlock.getBoundingClientRect();
      setStickyVisible(rect.bottom < 8);
    }

    initStickyDropdowns(sectionEl, sectionId);

    var stickyAddBtn = stickyBar.querySelector('[data-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        performAddToCart(sectionEl, sectionId, stickyAddBtn);
      });
    }

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', updateStickyVisibility);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(updateStickyVisibility);
    }
    updateStickyVisibility();
    syncStickySelectsFromMain(sectionEl);
  }

  function initSection(sectionEl) {
    if (!sectionEl || !sectionEl.classList.contains('product-detail-bison')) return;
    var sectionId = getSectionId(sectionEl);
    if (!sectionId) return;
    syncMediaLayoutMode(sectionEl);

    updateThumbnailArrowsVisibility(sectionEl);
    if (!sectionEl.__pdbThumbResizeBound) {
      sectionEl.__pdbThumbResizeBound = true;
      window.addEventListener('resize', function() {
        updateThumbnailArrowsVisibility(sectionEl);
      });
    }

    // Color items: single active, then update variant
    var colorItems = sectionEl.querySelectorAll('.color-item');
    colorItems.forEach(function(item) {
      item.addEventListener('click', function() {
        if (this.classList.contains('is-unavailable')) return;
        var scroll = this.closest('.product-detail-option-color') || this.closest('.color-scroll');
        if (scroll) scroll.querySelectorAll('.color-item').forEach(function(i) { i.classList.remove('active'); });
        this.classList.add('active');
        updateOptionAvailability(sectionEl, sectionId);
        updateVariantFromOptions(sectionEl, sectionId);
        updateColorArrowsVisibility();
      });
    });

    // Show/hide color arrows based on whether strip overflows (few vs many variants)
    function updateColorArrowsVisibility() {
      var optionColor = sectionEl.querySelector('.product-detail-option-color');
      var colorScroll = sectionEl.querySelector('.color-scroll');
      if (!optionColor || !colorScroll) return;
      var needsScroll = colorScroll.scrollWidth > colorScroll.clientWidth;
      optionColor.classList.toggle('color-no-scroll', !needsScroll);
    }
    updateColorArrowsVisibility();
    window.addEventListener('resize', updateColorArrowsVisibility);

    // Pack / other option buttons: single active per group, then update variant
    sectionEl.querySelectorAll('.product-detail-option').forEach(function(optionGroup) {
      var btns = optionGroup.querySelectorAll('.pack-btn');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (this.classList.contains('is-unavailable') || this.disabled) return;
          btns.forEach(function(b) { b.classList.remove('active'); });
          this.classList.add('active');
          updateOptionAvailability(sectionEl, sectionId);
          updateVariantFromOptions(sectionEl, sectionId);
          updateColorArrowsVisibility();
        });
      });
    });

    updateOptionAvailability(sectionEl, sectionId);
    updateVariantFromOptions(sectionEl, sectionId);
    updateColorArrowsVisibility();

    // Quantity (input allows manual typing; +/- buttons update it)
    var qtyWrap = sectionEl.querySelector('.quantity-control');
    if (qtyWrap) {
      var minusBtn = qtyWrap.querySelector('.qty-minus');
      var plusBtn = qtyWrap.querySelector('.qty-plus');
      var qtyInput = qtyWrap.querySelector('.qty-val');
      var minQty = 1;
      var maxQty = 99;
      function clampQty(val) {
        var n = parseInt(val, 10);
        if (isNaN(n) || n < minQty) return minQty;
        if (n > maxQty) return maxQty;
        return n;
      }
      function setQty(val) {
        var n = clampQty(val);
        if (qtyInput) {
          qtyInput.value = n;
          if (qtyInput.value !== String(n)) qtyInput.value = n;
        }
        return n;
      }
      function getQty() {
        if (!qtyInput) return 1;
        return clampQty(qtyInput.value || qtyInput.textContent);
      }
      if (minusBtn) minusBtn.addEventListener('click', function() {
        setQty(getQty() - 1);
      });
      if (plusBtn) plusBtn.addEventListener('click', function() {
        setQty(getQty() + 1);
      });
      if (qtyInput && qtyInput.addEventListener) {
        qtyInput.addEventListener('change', function() {
          setQty(this.value);
        });
        qtyInput.addEventListener('blur', function() {
          setQty(this.value);
        });
      }
    }

    // Add to cart button
    var addBtn = sectionEl.querySelector('.product-detail-add-btn');
    updateAddButtonState(sectionEl, getSelectedVariant(sectionEl, sectionId));
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        performAddToCart(sectionEl, sectionId, addBtn);
      });
    }

    // Share button: native share or copy link
    var shareBtn = sectionEl.querySelector('.product-detail-share-btn');
    var shareMessage = sectionEl.querySelector('[data-share-message]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        var url = this.getAttribute('data-share-url') || (typeof window !== 'undefined' && window.location && window.location.href) || '';
        var title = this.getAttribute('data-share-title') || '';
        if (!url) return;
        var successMsg = (typeof window !== 'undefined' && window.accessibilityStrings && window.accessibilityStrings.shareSuccess) || 'Link copied to clipboard';
        if (typeof navigator !== 'undefined' && navigator.share) {
          navigator.share({ url: url, title: title, text: title }).then(function() {
            if (shareMessage) { shareMessage.textContent = successMsg; shareMessage.classList.remove('visually-hidden'); setTimeout(function() { shareMessage.textContent = ''; shareMessage.classList.add('visually-hidden'); }, 2000); }
          }).catch(function() {});
        } else if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function() {
            if (shareMessage) { shareMessage.textContent = successMsg; shareMessage.classList.remove('visually-hidden'); setTimeout(function() { shareMessage.textContent = ''; shareMessage.classList.add('visually-hidden'); }, 2000); }
          });
        }
      });
    }

    // Buy Now: add to cart and redirect to checkout
    var buyNowBtn = sectionEl.querySelector('.buy-now-btn');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        var variant = getSelectedVariant(sectionEl, sectionId);
        var qtyEl = sectionEl.querySelector('.qty-val');
        var qty = (qtyEl && (parseInt(qtyEl.value || qtyEl.textContent, 10) || 1)) || 1;
        qty = Math.min(99, Math.max(1, isNaN(qty) ? 1 : qty));
        if (!variant || !variant.available) return;
        var formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', qty);
        buyNowBtn.disabled = true;
        buyNowBtn.classList.add('loading');
        var routes = typeof window !== 'undefined' && window.routes;
        var cartAddUrl = (routes && routes.cart_add_url) || '/cart/add.js';
        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData
        }).then(function(res) { return res.json(); }).then(function(data) {
          if (data.status) return;
          window.location = '/checkout';
        }).catch(function() {}).finally(function() {
          buyNowBtn.disabled = false;
          buyNowBtn.classList.remove('loading');
        });
      });
    }

    sectionEl.querySelectorAll('.subscribe-btn').forEach(function(btn) {
      btn.addEventListener('click', function() { this.classList.toggle('active'); });
    });

    initSplitScroll(sectionEl);
    initDetailRecommendations(sectionEl);
    initProductLightbox(sectionEl, sectionId);
    initStickyMobileAtc(sectionEl, sectionId);
    initJudgemeReviewsLink(sectionEl);
  }

  window.scrollThumbnailsBison = function(direction, btn) {
    var section = btn && btn.closest('.product-detail-bison');
    var container = section && section.querySelector('.product-thumbnails');
    if (!container) return;
    var first = container.querySelector('.thumbnail-item');
    var step = (first ? first.offsetWidth + (parseFloat(getComputedStyle(container).gap) || 12) : 62);
    container.scrollLeft += direction * step;
  };

  window.scrollColorsBison = function(direction, btn) {
    var section = btn && btn.closest('.product-detail-bison');
    var container = section && section.querySelector('.color-scroll');
    if (!container) return;
    var first = container.querySelector('.color-item');
    var step = (first ? first.offsetWidth + (parseFloat(getComputedStyle(container).gap) || 8) : 58);
    container.scrollLeft += direction * step;
  };

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-detail-bison').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function(e) {
    var el = e.target.querySelector && e.target.querySelector('.product-detail-bison');
    if (!el && e.target.classList && e.target.classList.contains('product-detail-bison')) el = e.target;
    if (el) initSection(el);
  });
})();
